import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

import { classes as contentClasses } from './getContentCss';

export const classes = generateEmotionClasses('temporaryDrawer', [
  'container',
  'scrollContainer',
  'anchorLeft',
  'anchorRight',
  'widthMedium',
  'widthLarge',
  'stickyNone',
  'stickyActions',
  'stickyHeadingGroup',
  'notPaddedContent',
  'noActionsSection',
]);

const getTemporaryDrawerCss = css`
  background-color: var(--cds-color-neutral-background-primary);
  position: fixed;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  padding: var(--cds-spacing-200) 0;

  .${classes.container} {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .${classes.scrollContainer} {
    flex: 1 1 auto;
  }

  &.${classes.anchorLeft} {
    left: 0;
    right: auto;
  }

  &.${classes.anchorRight} {
    right: 0;
    left: auto;
  }

  &.${classes.stickyActions} {
    padding-top: 0;

    .${classes.scrollContainer} {
      padding-top: var(--cds-spacing-200);
    }
  }

  &.${classes.stickyHeadingGroup} {
    padding-bottom: 0;

    .${classes.scrollContainer} {
      padding-bottom: var(--cds-spacing-200);
    }
  }

  &.${classes.stickyNone} {
    padding: 0;

    .${classes.scrollContainer} {
      padding: var(--cds-spacing-200) 0;
    }
  }

  ${breakpoints.up('sm')} {
    max-width: 450px;
    padding: var(--cds-spacing-200) 0;

    &.${classes.stickyActions} {
      padding-top: 0;

      .${classes.scrollContainer} {
        padding-top: var(--cds-spacing-200);
      }
    }

    &.${classes.stickyHeadingGroup} {
      padding-bottom: 0;

      .${classes.scrollContainer} {
        padding-bottom: var(--cds-spacing-200);
      }
    }

    &.${classes.stickyNone} {
      padding: 0;

      .${classes.scrollContainer} {
        padding: var(--cds-spacing-200) 0;
      }
    }
  }

  ${breakpoints.up('md')} {
    padding: var(--cds-spacing-300) 0;

    &.${classes.stickyActions} {
      padding-top: 0;

      .${classes.scrollContainer} {
        padding-top: var(--cds-spacing-300);
      }
    }

    &.${classes.stickyHeadingGroup} {
      padding-bottom: 0;

      .${classes.scrollContainer} {
        padding-bottom: var(--cds-spacing-300);
      }
    }

    &.${classes.stickyNone} {
      padding: 0;

      .${classes.scrollContainer} {
        padding: var(--cds-spacing-300) 0;
      }
    }

    &.${classes.widthMedium} {
      max-width: 512px;
    }

    &.${classes.widthLarge} {
      max-width: 768px;
    }
  }

  ${breakpoints.up('lg')} {
    &.${classes.widthMedium} {
      max-width: 720px;
    }

    &.${classes.widthLarge} {
      max-width: 1080px;
    }
  }

  &.${classes.notPaddedContent}.${classes.noActionsSection} {
    .${classes.scrollContainer} {
      padding-bottom: 0;
    }
  }

  &.${classes.notPaddedContent} {
    .${contentClasses.root} {
      padding: 0;
    }
  }
`;

export default getTemporaryDrawerCss;
